import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause } from '@fortawesome/free-solid-svg-icons';
import './Queue.scss';
import { useSelector } from 'react-redux';
import { authSelector } from '../../../selectors/mainSelectors.js';
import classNames from 'classnames';
import { selectedUserIdSelector } from '../../../selectors/userSelectors.js';
import { useGetUnnoticedUsersQuery, useGetUserInfoQuery } from '../../../api/userApi.js';
import askDisabled from '../../../assets/img/ask-disabled.png';
import BlueDotIcon from '../../../assets/img/blue-dot.svg?react';
import { Box, Stack, Typography } from '@mui/material';

const Queue = ({ type, title, users, onUserClick }) => {
  const selectedUserId = useSelector(selectedUserIdSelector);
  const { data: userInfo } = useGetUserInfoQuery(selectedUserId, {
    skip: !selectedUserId
  });

  const { user: bookkeeper } = useSelector(authSelector);

  const { data: unnoticedUsers = [], isLoading: areUnnoticedUsersLoading } = useGetUnnoticedUsersQuery();

  if (areUnnoticedUsersLoading) {
    return null;
  }

  return (
    <>
      <Typography className={`queue-header ${type}`}>{title}</Typography>
      {users.map((user) => (
        <div className='queue-user' key={user.userId}>
          <button
            type='button'
            className={classNames(`queue-user-button`, {
              active: userInfo?.id === user.userId
            })}
            onClick={() => onUserClick(user.userId)}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography className='queue-user-text'>
                {user.firstName} {!user.autoPredict ? '(M)' : ''}
              </Typography>
              <Stack
                direction='row'
                spacing={1}
                sx={{
                  alignItems: 'center',
                  marginLeft: 'auto',
                  marginRight: 1
                }}
              >
                {!user.isAskEnabled && (
                  <img
                    alt='Ask Disabled'
                    src={askDisabled}
                    style={{
                      width: '18px',
                      height: '18px'
                    }}
                  />
                )}
                {user.isOnHold && user.holdingBookkeeperId !== bookkeeper.id && (
                  <FontAwesomeIcon
                    icon={faPause}
                    style={{
                      width: '18px',
                      height: '18px'
                    }}
                  />
                )}
                {unnoticedUsers.indexOf(user.userId) !== -1 && <BlueDotIcon width={13} height={13} />}
              </Stack>
            </Box>
          </button>
        </div>
      ))}
    </>
  );
};

Queue.propTypes = {
  type: PropTypes.oneOf(['normal', 'priority', 'hold', 'extended']).isRequired
};

export default Queue;
